<template>
  <div class="div1">
  <h5>简易图书管理</h5>
  <p>
    <label>id: <input type="number" min="1" placeholder="请输入序号" v-model.number="id" required> </label>
    <label>图书名称: <input type="text" placeholder="请输入图书名称" v-model="bookname" required> </label>
    <label>出版社: <input type="text" placeholder="请输入出版社" v-model="press" required> </label>
    <label>作者: <input type="text" placeholder="请输入作者" v-model="author" required> </label>
    <button @click="add">添加</button>
    <button @click="update" :disabled="hbId===0" :class="{'btn-disabled': hbId===0}">更新</button><br>
  </p>
  <p>
    <label>请输入搜索关键字:
      <input type="text" placeholder="请输入搜索关键字" v-model="keyword">
    </label>
    <button @click="search(keyword)">搜索</button>
  </p>

  <table v-if="bookLists.length > 0" border>
    <thead>
      <tr class="tr1">
        <th>序号</th>
        <th>图书名称</th>
        <th>出版社</th>
        <th>作者</th>
        <th>时间</th>
        <th>操作</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in search(keyword)" :key="item.id" class="tr1">
        <td>{{item.id}}</td>
        <td>{{item.bookname}}</td>
        <td>{{item.press}}</td>
        <td>{{item.author}}</td>
        <td>{{item.ptime}}</td>
        <td>
          <a class="btn-success" @click="editBook(item.id)">编辑</a>
          <a class="btn-success" @click="deleteBook(item.id)">删除</a>
        </td>
      </tr>
    </tbody>
  </table>
  <h5 v-else>没书了。抓紧时间补库存</h5>

  <h5>共{{ bookLists.length }}本书</h5>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'BooksDb',
  data () {
    return {
      keyword: '',
      id: '',
      hbId: 0,
      bookname: '',
      press: '',
      author: '',
      bookLists: []
    }
  },
  methods: {
    checkInput (update) { // update为true，表示是更新
      // 数据不为空，才能添加和更新
      if (this.id !== '' && this.bookname !== '' && this.press !== '' && this.author !== '') {
        if (update && this.id === this.hbId) { // 若是更新，则id可以是自己
          return true
        }
        if (this.bookLists.findIndex((item) => (item.id === this.id)) !== -1) {
          alert('图书序号重复，请修改！！')
          return false
        } else if (this.id < 1) {
          alert('图书序号需要最小为1')
          return false
        } else {
          return true
        }
      } else {
        alert('图书数据不完整！，请补充！！')
        return false
      }
    },
    add () {
      if (this.checkInput()) {
        const that = this
        // axios.get(`/api/addBook?id=${that.id}&bookname=${that.bookname}&press=${that.press}&author=${that.author}`)
        axios({
          method: 'POST',
          url: '/api/addBook',
          params: {
            id: that.id,
            bookname: that.bookname,
            press: that.press,
            author: that.author
          }
        }).then(function (response) {
          console.log(response.data)
          that.bookLists.push({
            id: that.id,
            bookname: that.bookname,
            press: that.press,
            author: that.author,
            ptime: new Date()
          })
          that.hbId = that.id
          that.keyword = ''
          setTimeout(function () { alert('图书添加成功') })
          // that.$nextTick(function () {
          //  alert('图书添加成功')
          // })
        }).catch(function (error) {
          console.log(error)
        })
      }
    },
    search (bname) { // 返回满足条件的图书数组
      var arrBooks = []
      this.bookLists.forEach((item, i) => {
        if (item.bookname.indexOf(bname) !== -1) {
          arrBooks.push(item) // 当 bname="",indexOf(bname)=0,原数组自动push进来。
        }
      })
      return arrBooks
    },
    deleteBook (id) {
      var inx = this.bookLists.findIndex((item) => (item.id === id))
      const that = this
      axios.get('/api/delBook?id=' + id)
        .then(function (response) {
          console.log(response.data)
          that.bookLists.splice(inx, 1)
          if (that.hbId === id) {
            that.hbId = 0 // 删除的是自己
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    editBook (id) {
      var inx = this.bookLists.findIndex((item) => (item.id === id))
      this.id = this.bookLists[inx].id
      this.bookname = this.bookLists[inx].bookname
      this.press = this.bookLists[inx].press
      this.author = this.bookLists[inx].author
      this.hbId = id
    },
    update () {
      if (this.checkInput(true)) {
        var inx = this.bookLists.findIndex((item) => (item.id === this.hbId))
        const that = this
        // axios.get(`/api/updateBook?id=${that.hbId}&bookname=${that.bookname}&press=${that.press}&author=${that.author}&newid=${that.id}`)
        axios({
          method: 'POST',
          url: '/api/updateBook',
          // params: {
          data: {
            id: that.hbId,
            bookname: that.bookname,
            press: that.press,
            author: that.author,
            newid: that.id
          }
        }).then(function (response) {
          console.log(response.data)
          that.bookLists[inx].id = that.id
          that.bookLists[inx].bookname = that.bookname
          that.bookLists[inx].press = that.press
          that.bookLists[inx].author = that.author
          that.hbId = that.id
        }).catch(function (error) {
          console.log(error)
        })
      }
    }
  },
  filters: {
    dateFormat (date) {
      var dy = date.getFullYear()
      var dm = date.getMonth() + 1
      var dd = date.getDate()
      var dh = date.getHours()
      var dms = date.getMinutes()
      var ds = date.getSeconds()
      return `${dy}-${dm}-${dd}  ${dh}:${dms}:${ds}`
    }
  },
  created () {
    const that = this
    axios.get('/api/getBooks')
      .then(function (response) {
        console.log(response.data)
        that.bookLists = response.data.data
      })
      .catch(function (error) {
        console.log(error)
      })
  }
}
</script>

<style scoped>
.div1 {margin: 0 auto;width: 950px;border: 1px dashed #55ed89;}
table {
  border: 1px solid #42B983;text-align: center;
  width: 950px;border-collapse: collapse;
}
th {background: #ABB983;}
.tr1 {height: 50px;padding: 5px auto;}
h5 {
  text-align: center;color: #0033CC;padding: 15px;
  background: #AFAFAF;font-size: 28px;
}
/*定义input标记样式 */
input {
  border-radius: 8px;width: 140px;
  height: 35px;border: 1px dashed #008000;
}
/*定义button,超链接标记样式 */
button,
.btn-success {
  border-radius: 8px;width: 70px;height: 35px;
  background: #008000;color: white;
}
.btn-disabled {
  background: grey;
}
a {
  padding: 8px 10px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/BooksDb.vue